import { MdOutlineRadioButtonChecked, MdOutlineRadioButtonUnchecked } from "react-icons/md";
import { Label, RadioBlock, RadioInput, Wrapper } from "./style";

const RadioButtonComponent = ({ value = false, onChange, label, hasLabel = true }) => {
  return (
    <Wrapper>
      <RadioInput type="radio" onChange={onChange} checked={value} readOnly={!onChange} />

      <Label>
        <RadioBlock checked={value} $hasLabel={hasLabel} $checked={value}>
          {value ? (
            <MdOutlineRadioButtonChecked className="radio_icon" />
          ) : (
            <MdOutlineRadioButtonUnchecked className="radio_icon" />
          )}
          {value}
        </RadioBlock>
        {label}
      </Label>
    </Wrapper>
  );
};

export default RadioButtonComponent;

/* <MdOutlineRadioButtonChecked className="checked-icon" />; */
// <MdOutlineRadioButtonUnchecked />;
